import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import UserAvatar from '../../images/user-avatar-32.png';

function ForumEntries({ filter, posts, followedStocks = [] }) {
  const navigate = useNavigate();
  console.log('FollowedStocks:', followedStocks); // Debug

  const handlePostClick = (postId) => {
    navigate(`/community/forum-post/${postId}`);
  };

  const filteredPosts = () => {
    if (filter === 'following') {
      console.log('Filtering posts for followed stocks'); // Debug
      return posts.filter(post => 
        followedStocks.some(stock => {
          console.log('Comparing:', stock.symbol, post.stockSymbol); // Debug
          return stock.symbol?.toLowerCase() === post.stockSymbol?.toLowerCase();
        })
      );
    }
    return posts;
  };

  const displayPosts = filteredPosts();
  console.log('DisplayPosts:', displayPosts); // Debug

  if (!displayPosts || displayPosts.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500 dark:text-gray-400">
          {filter === 'liked'
            ? 'Du har ikke liket nogen indlæg endnu'
            : filter === 'following' && (!followedStocks || followedStocks.length === 0)
            ? 'Du følger ingen aktier lige nu'
            : filter === 'following'
            ? 'Ingen indlæg fra dine fulgte aktier'
            : 'Ingen indlæg at vise'}
        </p>
      </div>
    );
  }

  return (
    <>
      {displayPosts.map((post) => (
        <article
          key={post.id}
          className="bg-white dark:bg-gray-800 shadow-sm rounded-xl p-5 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/20"
          onClick={() => handlePostClick(post.id)}
        >
          <div className="flex flex-start space-x-4">
            <div className="shrink-0 mt-1.5">
              <img
                className="w-8 h-8 rounded-full"
                src={post.authorPhotoURL || UserAvatar}
                width="32"
                height="32"
                alt={post.authorName || 'User'}
              />
            </div>
            <div className="grow">
              <h2 className="font-semibold text-gray-800 dark:text-gray-100 mb-2">
                <Link
                  to={`/community/forum-post/${post.id}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  {post.title}
                </Link>
              </h2>
              <footer className="flex flex-wrap text-sm">
                <div className="flex items-center after:block after:content-['·'] last:after:content-[''] after:text-sm after:text-gray-400 dark:after:text-gray-600 after:px-2">
                  <span className="font-medium text-violet-500">
                    {post.authorName}
                  </span>
                </div>
                <div className="flex items-center after:block after:content-['·'] last:after:content-[''] after:text-sm after:text-gray-400 dark:after:text-gray-600 after:px-2">
                  <span className="text-gray-500">
                    {post.timestamp?.toDate().toLocaleDateString()}
                  </span>
                </div>
                <div className="flex items-center after:block after:content-['·'] last:after:content-[''] after:text-sm after:text-gray-400 dark:after:text-gray-600 after:px-2">
                  <span className="text-gray-500">{post.commentCount || 0} Kommentarer</span>
                </div>
                <div className="flex items-center last:after:content-[''] after:text-sm after:text-gray-400 dark:after:text-gray-600">
                  <span className="text-gray-500">{post.stockSymbol || post.stockName}</span>
                </div>
              </footer>
            </div>
            <div className="shrink-0">
              <div
                className={`text-xs font-semibold text-center h-12 w-12 border ${
                  'border-gray-200 dark:border-gray-700/60 hover:border-gray-300 dark:hover:border-gray-600'
                } rounded-lg flex flex-col justify-center items-center text-gray-400 dark:text-gray-500`}
              >
                <svg
                  className="inline-flex mt-1.5 mb-1.5 fill-gray-400 dark:fill-gray-500"
                  width="12"
                  height="6"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m0 6 6-6 6 6z" />
                </svg>
                {post.upvotes || 0}
              </div>
            </div>
          </div>
        </article>
      ))}
    </>
  );
}

export default ForumEntries;